var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoResults = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 678,
    height: 630,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.377 346.5v7.21",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.182 350.405 5.892 6.065M5.292 366.55h8.33M11.507 382.982l5.891-6.065"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.377 384.954v-7.21M40.393 380.147l-4.806-4.807M50.007 368.13h-7.21M45.2 351.306l-4.807 4.807M353.897 6v4.807M339.477 20.42h4.807M353.897 34.84v-4.806M365.914 20.42h-4.807M75.11 207.88v7.21M53.48 229.51h7.21M75.11 248.737v-7.21M94.337 229.51h-7.21M592.437 469.939c5.744 0 10.402 4.659 10.402 10.404 0 5.747-4.658 10.404-10.402 10.404-5.743 0-10.401-4.657-10.401-10.404",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640.039 375.546c6.176-1.927 15.644-9.48 17.835-17.607 1.987 7.184 10.318 15.68 17.834 16.323-8.461 2.996-16.551 11.896-17.834 18.888-.873-7.127-12.063-16.566-17.835-17.604ZM99 493.302c3.089-.963 7.821-4.739 8.916-8.802.994 3.59 5.158 7.839 8.916 8.161-4.229 1.496-8.273 5.948-8.916 9.444-.436-3.564-6.031-8.284-8.916-8.803Z",
    fill: "#EBECEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.391 132.409a8.066 8.066 0 1 1-16.13 0 8.065 8.065 0 1 1 16.13 0Z",
    fill: "#D1D8DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M569.255 74.984c0 7.447-6.038 13.484-13.481 13.484-7.447 0-13.482-6.037-13.482-13.484S548.327 61.5 555.774 61.5c7.443 0 13.481 6.037 13.481 13.484ZM530.676 249.196c0 5.908-4.786 10.696-10.691 10.696-5.907 0-10.693-4.788-10.693-10.696 0-5.908 4.786-10.696 10.693-10.696 5.905 0 10.691 4.788 10.691 10.696Z",
    fill: "#EBECEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M214.127 617.091a6.74 6.74 0 1 1-13.48 0 6.74 6.74 0 1 1 13.48 0ZM210.117 80.58a8.066 8.066 0 1 1-16.131 0 8.067 8.067 0 1 1 16.131 0ZM418.538 599.823c-5.154 1.962-10.922-.628-12.883-5.781-1.96-5.156.627-10.927 5.783-12.886 5.152-1.962 10.92.626 12.88 5.781 1.963 5.156-.626 10.925-5.78 12.886Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.777 501.087H215.692c-13.872 0-25.227-11.388-25.227-25.307V194.728c0-13.919 11.355-25.301 25.227-25.301h197.085c13.877 0 25.232 11.382 25.232 25.301V475.78c0 13.919-11.355 25.307-25.232 25.307Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.953 513.104H198.869c-13.872 0-25.227-11.388-25.227-25.307V206.745c0-13.919 11.355-25.301 25.227-25.301h197.084c13.878 0 25.233 11.382 25.233 25.301v281.052c0 13.919-11.355 25.307-25.233 25.307Z",
    fill: "#E8EBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.589 522.59H182.097c-13.9 0-25.278-11.341-25.278-25.202V217.5c0-13.861 11.378-25.197 25.278-25.197h197.492c13.907 0 25.285 11.336 25.285 25.197v279.888c0 13.861-11.378 25.202-25.285 25.202Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.589 522.59H182.097c-13.9 0-25.278-11.341-25.278-25.202V217.5c0-13.861 11.378-25.197 25.278-25.197h197.492c13.907 0 25.285 11.336 25.285 25.197v279.888c0 13.861-11.378 25.202-25.285 25.202Z",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.123 277.577H205.251c-4.166 0-7.576-3.244-7.576-7.207 0-3.969 3.41-7.213 7.576-7.213h145.872c4.166 0 7.576 3.244 7.576 7.213 0 3.963-3.41 7.207-7.576 7.207ZM351.123 320.837H205.251c-4.166 0-7.576-3.244-7.576-7.208 0-3.968 3.41-7.212 7.576-7.212h145.872c4.166 0 7.576 3.244 7.576 7.212 0 3.964-3.41 7.208-7.576 7.208ZM351.123 364.097H205.251c-4.166 0-7.576-3.244-7.576-7.207 0-3.963 3.41-7.213 7.576-7.213h145.872c4.166 0 7.576 3.25 7.576 7.213s-3.41 7.207-7.576 7.207ZM351.123 407.357H205.251c-4.166 0-7.576-3.244-7.576-7.207 0-3.969 3.41-7.213 7.576-7.213h145.872c4.166 0 7.576 3.244 7.576 7.213 0 3.963-3.41 7.207-7.576 7.207ZM281.394 450.617h-76.11c-4.184 0-7.609-3.244-7.609-7.208 0-3.968 3.425-7.212 7.609-7.212h76.11c4.184 0 7.608 3.244 7.608 7.212 0 3.964-3.424 7.208-7.608 7.208Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.017 394.708c-29.169 29.164-74.325 32.454-107.109 9.938-4.189-2.93-8.177-6.22-11.896-9.938a80.213 80.213 0 0 1-5.419-5.95c-3.401-4.14-6.379-8.555-8.82-13.117a80.388 80.388 0 0 1-8.819-24.333c-5.15-26.503 2.55-55.031 23.058-75.529 20.557-20.559 49.089-28.209 75.597-23.109a83.176 83.176 0 0 1 24.337 8.818c4.569 2.495 8.924 5.473 13.071 8.873a80.211 80.211 0 0 1 5.945 5.418c3.724 3.718 7.064 7.699 9.939 11.894 22.526 32.772 19.229 77.927-9.884 107.035Z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.855 388.965c-30.346 30.351-79.524 30.346-109.876 0-30.312-30.312-30.312-79.496.04-109.842 30.312-30.312 79.49-30.312 109.802 0 30.346 30.346 30.346 79.53.034 109.842Zm15.574-125.434c-38.952-38.952-102.072-38.952-141.024 0-38.946 38.946-38.98 102.106-.034 141.057 35.451 35.44 91.016 38.636 130.097 9.538a101.356 101.356 0 0 0 11-9.538c3.501-3.506 6.692-7.183 9.532-11 29.098-39.087 25.874-94.612-9.571-130.057Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m595.721 551.418-1.635 1.635c-10.819 10.824-28.535 10.824-39.36 0l-99.894-99.894 40.995-40.994 99.894 99.894c10.824 10.824 10.824 28.534 0 39.359Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.153 390.535 29.519 29.519-20.956 20.951-29.514-29.519c3.895-2.904 7.641-6.16 11.225-9.733a102.061 102.061 0 0 0 9.726-11.218Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m594.226 510.83-40.734 40.728-7.333-7.339 40.728-40.728 7.339 7.339Z",
    fill: "#1236A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m498.092 413.575-41.849 41.849-6.217-6.217 41.849-41.849 6.217 6.217Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.766 268.682 304.135 371.308a72.126 72.126 0 0 1-7.923-21.875l88.677-88.678a74.915 74.915 0 0 1 21.877 7.927ZM440.412 293.075 329.457 397.744c-3.973-2.615-7.755-5.559-11.282-8.887a73.157 73.157 0 0 1-5.14-5.324l112.307-105.955a74.548 74.548 0 0 1 5.644 4.854c3.527 3.327 6.7 6.889 9.426 10.643Z",
    fill: "#fff",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 529.336,
    y1: 337.661,
    x2: 380.329,
    y2: 486.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#235EFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 474.059,
    y1: 383.324,
    x2: 425.992,
    y2: 431.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#235EFB"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoResults);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/noResults.278cd1840d40d8d7bd0534d081dafe96.svg";